import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';
import ErrorIcon from 'Components/ComponentLibrary/Components/Uncategorized/Icons/ErrorIcon';

const useStyles = buildUseStyles('PaymentDetails', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  flexColumn: {
    flexDirection: 'column',
  },
  img: {
    maxHeight: theme.spacing(3), // spacing is used here because we want this to be sized in relation to font.
    objectFit: 'none',
    marginRight: theme.spacing(2),
    fontSize: 0,
  },
  text: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  details: {
    fontSize: theme.typography.fontSize1Pt125Rem,
    marginRight: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  imgMobile: {
    maxWidth: theme.spacing(7),
  },
  detailsMobile: {
    fontSize: theme.typography.fontSizePt875Rem,
  },
}));

const PaymentDetails = ({
  className,
  imgSrc,
  details,
  additionalInformation,
  typographyClassName,
  imgClassName,
  expirationDateString,
  expired,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.flexRow}>
        {imgSrc && (
          <img
            className={classNames(imgClassName, classes.img, { [classes.imgMobile]: isMobile })}
            src={imgSrc}
            alt={'payment-details-logo'}
          />
        )}
        <Box className={classNames(classes.flexRow, { [classes.flexColumn]: isMobile })}>
          <Typography
            className={classNames(classes.text, classes.details, typographyClassName, { [classes.detailsMobile]: isMobile })}
            color={'darkGray'}
          >
            {details}
          </Typography>
          {expired && (
            <Box className={classes.flexRow}>
              <ErrorIcon
                size={'small'}
                className={classes.icon}
              />
              <Typography
                className={classNames(classes.text, classes.additionalInformation)}
                color={'red'}
              >
                {`Expired on ${expirationDateString}`}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box>
        <Typography
          className={classNames(classes.text, classes.additionalInformation)}
          variant={'h6'}
          color={'darkGray'}
        >
          {additionalInformation}
        </Typography>
      </Box>
    </Box>
  );
};

PaymentDetails.defaultProps = {
  className: '',
  imgSrc: '',
  details: '',
  additionalInformation: '',
  typographyClassName: '',
  imgClassName: '',
  expirationDateString: '',
  expired: false,
};

PaymentDetails.propTypes = {
  className: PropTypes.string,
  imgSrc: PropTypes.string,
  details: PropTypes.string,
  additionalInformation: PropTypes.string,
  typographyClassName: PropTypes.string,
  imgClassName: PropTypes.string,
  expirationDateString: PropTypes.string,
  expired: PropTypes.bool,
};

export default PaymentDetails;
